"use client";

import { Banknote, Leaf, ShieldCheck, Truck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Reliable & Professional",
  description: "Fast response times and dependable service you can count on across all major BC locations.",
  icon: ShieldCheck
}, {
  title: "Eco-Conscious Recycling",
  description: "We ensure your scrap vehicle is disposed of and recycled using environmentally friendly practices.",
  icon: Leaf
}, {
  title: "Instant Cash Offers",
  description: "Get top dollar for your junk car with our competitive, on-the-spot cash payouts.",
  icon: Banknote
}, {
  title: "Same-Day Free Towing",
  description: "Enjoy the convenience of free, same-day pickup and towing services right from your driveway.",
  icon: Truck
}];
export default function WhyBcChoosesUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-bc-chooses-us" className="dark bg-background text-foreground relative py-20 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/bc_mountains_background.png)] bg-cover bg-center bg-no-repeat" />
      <div className="absolute inset-0 bg-background/90 backdrop-blur-[2px]" />

      <div className="relative z-10 container mx-auto px-4 md:px-6" ref={ref}>
        {}
        <div className={`text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-foreground">
            Why BC Chooses Us
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            The trusted choice for junk car removal across British Columbia, combining high payouts with eco-friendly practices.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full bg-card/40 backdrop-blur-md border-border/30 shadow-2xl hover:shadow-primary/10 hover:border-primary/30 transition-all duration-300 rounded-[5px] overflow-hidden group">
                <CardContent className="p-8 md:p-10 flex flex-col gap-5">
                  <div className="size-14 rounded-[5px] bg-primary/10 flex items-center justify-center text-primary mb-2 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <feature.icon className="size-7" />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-semibold text-foreground tracking-tight">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-base md:text-lg leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}